import useUser from './useUser';
import useAutofetchedAccountsAsync from './useAutofetchedAccountsAsync';

import formatWorkflowUser, { IWorkflowUserName } from 'utils/formatWorkflowUser';

export default function useWorkflowUser(userId: string): IWorkflowUserName {
  const user = useUser(userId);
  const accountsAsync = useAutofetchedAccountsAsync();

  const account = accountsAsync.data && accountsAsync.data.find((account) => account.id === userId);

  return formatWorkflowUser(userId, user || undefined, account || undefined);
}
